import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {Constant} from 'config/constant';
import {RootState} from 'redux/store';
import {getErrorMessage,} from 'api';
import { logout } from './authSlice';
import {
    RegisterFacilityTypeData
} from 'types';
import {createFacilityType, getListFacilityType, UpdateFacilityType, deleteFacilityType} from 'api/facilityType';

export type facilityTypeData = {
    uuid: string,
    name: string
}
export type ListFacilityType = {
    error: boolean;
    loading: boolean;
    success: boolean;
    facilityType: facilityTypeData[];
    status: string;
};

export type FacilityTypeState = {
    status: number;
    facilityTypeData: facilityTypeData[];
    listFacilityType: ListFacilityType;
    detailsFacilityType: facilityTypeData;
    register: {
        loading: boolean;
        success: boolean;
        error: boolean;
        message: string;
    };
    update: {
        success: boolean;
        error: boolean;
        messages: string;
        loading: boolean;
    };
    delete: {
        success: boolean;
        error: boolean;
        messages: string;
        loading: boolean;
    };
    detail: {
        success: boolean;
        error: boolean;
        messages: string | RegisterFacilityTypeData;
        loading: boolean;
        dataDetail: facilityTypeData;
    };
}

export const createFacilityTypeA = createAsyncThunk(
    'admin/facility-type/store',
    async (params: RegisterFacilityTypeData, { dispatch, rejectWithValue }) => {
        try {
            let response = await createFacilityType(params);
            const { data = {}, success } = response.data;
            if (success) {

                dispatch(setNewFacilityType(data));
                return true;
            }
        } catch (error: any) {
            if (error?.response?.data?.message === "TOKEN_EXPIRED") {
                dispatch(logout());
            }
            dispatch(setNewFacilityType(error));
            return rejectWithValue(getErrorMessage(error));
        }
    }
);

export const updateFacilityType = createAsyncThunk(
    '/admin/facility-type/update',
    async (params: { uuid: string, name: string, en_name: string, lang:string }, { dispatch, rejectWithValue }) => {
        try {
            let response = await UpdateFacilityType(params);
            const { success } = response.data;
            if (success) {
            dispatch(setUpdateFacilityType({params}));
                return true;
            }
        } catch (error: any) {
            if (error?.response?.data?.message === "TOKEN_EXPIRED") {
                dispatch(logout());
            }
            dispatch(setUpdateFacilityType(error));
            return rejectWithValue(getErrorMessage(error));
        }
    }
);

export const destoryFacilityType = createAsyncThunk(
    '/admin/facility-type/delete',
    async (params: { uuid: string, lang:string }, { dispatch, rejectWithValue }) => {
        try {
            let response = await deleteFacilityType(params);
            const { success } = response.data;
            if (success) {
            dispatch(setDeleteFacilityType({params}));
                return true;
            }
        } catch (error: any) {
            if (error?.response?.data?.message === "TOKEN_EXPIRED") {
                dispatch(logout());
            }
            dispatch(setDeleteFacilityType(error));
            return rejectWithValue(getErrorMessage(error));
        }
    }
);


export const facilityTypeSlice = createSlice(
    {
        name: 'facilityType',
        initialState: {
            status: Constant.DEFAULT_STATUS,
            facilityTypeData: [],
            register: {
                loading: false,
                success: false,
                error: false,
                message: '',
            },
            update: {
                success: false,
                error: false,
                messages: '',
                loading: false,
            },
            delete: {
                success: false,
                error: false,
                messages: '',
                loading: false,
            },
            listFacilityType: {
                error: false,
                loading: false,
                success: false,
                notification: [],
                pagination: {
                    total: 0,
                    perPage: Constant.PAGE_SIZE_NEW,
                    currentPage: Constant.DEFAULT_PAGE,
                    lastPage: Constant.DEFAULT_PAGE,
                },
                status: '',
            },
            listSearchPlace: {
                error: false,
                loading: false,
                success: false,
                places: [],
            }
        } as unknown as FacilityTypeState,
        reducers:{
            resetRegisterState: (state: FacilityTypeState) => {
                state.status = Constant.DEFAULT_STATUS;
                state.register = {
                    success: false,
                    loading: false,
                    message: '',
                    error: false,
                };
            },
            setNewFacilityType: (state, action) => {
                state.facilityTypeData = action?.payload ?? [];
                state.status = action?.payload?.response?.status;
                state.register.message = action?.payload?.response?.data?.message;
            },
            setListFacilityType: (state: FacilityTypeState, { payload }) => {
                state.listFacilityType.facilityType = payload ?? [];
            },
            setDetailsFacilityType:(state: FacilityTypeState, {payload}) => {
                state.detailsFacilityType = {
                    name: payload.detailsFacilityType.name,
                    uuid: payload.detailsFacilityType.uuid
                }
            },
            setDeleteFacilityType: (state: FacilityTypeState, { payload }) => {
                state.status = payload?.response?.status;
            },
            setUpdateFacilityType: (state, action) => {
                state.facilityTypeData = action?.payload?.params ?? [];
                state.status = action?.payload?.response?.status;
                state.update.messages = action?.payload?.response?.data?.message;
            },
            resetUpdateState: (state: FacilityTypeState) => {
                state.status = Constant.DEFAULT_STATUS;
                state.update = {
                    loading: false,
                    success: false,
                    error: false,
                    messages: '',
                };
            },
            resetDeleteState: (state: FacilityTypeState) => {
                state.status = Constant.DEFAULT_STATUS;
                state.delete = {
                    loading: false,
                    success: false,
                    error: false,
                    messages: '',
                };
            },
            resetListFacilityTypeState: (state: FacilityTypeState) => {
                state.status = Constant.DEFAULT_STATUS;
                state.update = {
                    loading: false,
                    success: false,
                    error: false,
                    messages: '',
                };
            }
        },
        extraReducers: (builder) => {
            builder
                .addCase(createFacilityTypeA.pending, (state: FacilityTypeState) => {
                    state.register.loading = true;
                })
                .addCase(createFacilityTypeA.rejected, (state: FacilityTypeState, { payload }) => {
                    state.register.loading = false;
                    state.register.success = false;
                    state.register.error = true;
                    state.register.message = payload as string;
                })
                .addCase(createFacilityTypeA.fulfilled, (state: FacilityTypeState) => {
                    state.register.loading = false;
                    state.register.success = true;
                    state.register.error = false;
                })
                .addCase(updateFacilityType.pending, (state: FacilityTypeState) => {
                    state.update.loading = true;
                })
                .addCase(updateFacilityType.rejected, (state: FacilityTypeState) => {
                    state.update.loading = false;
                    state.update.success = false;
                    state.update.error = true;
                })
                .addCase(updateFacilityType.fulfilled, (state: FacilityTypeState) => {
                    state.update.loading = false;
                    state.update.success = true;
                    state.update.error = false;
                })
                .addCase(fetchListFacilityType.pending, (state: FacilityTypeState) => {
                    state.listFacilityType.loading = true;
                })
                .addCase(fetchListFacilityType.rejected, (state: FacilityTypeState) => {
                    state.listFacilityType.loading = false;
                    state.listFacilityType.success = false;
                    state.listFacilityType.error = true;
                })
                .addCase(fetchListFacilityType.fulfilled, (state: FacilityTypeState) => {
                    state.listFacilityType.loading = false;
                    state.listFacilityType.success = true;
                    state.listFacilityType.error = false;
                })
                .addCase(destoryFacilityType.pending, (state: FacilityTypeState) => {
                    state.delete.loading = true;
                    state.delete.success = false;
                    state.delete.error = false;
                })
                .addCase(destoryFacilityType.rejected, (state: FacilityTypeState, {payload}) => {
                    state.delete.loading = false;
                    state.delete.success = false;
                    state.delete.error = true;
                    state.delete.messages = payload as string;
                })
                .addCase(destoryFacilityType.fulfilled, (state: FacilityTypeState) => {
                    state.delete.loading = false;
                    state.delete.success = true;
                    state.delete.error = false;
                })
        },
    }
);

export const fetchListFacilityType = createAsyncThunk(
    'admin/facility-type',
    async (params: {}, { dispatch, rejectWithValue }) => {
        try {
            const response = await getListFacilityType(params);
            const {
                data = [],
                success,
            } = response.data;


            if (success) {
                let m = 0;
                if(data.length>0) {
                    for (const elem of data) {
                        m+=1;
                        elem['no'] = m;
                    }
                }

               // dispatch(setListFacilityType({ FacilityType: data }));
                dispatch(setListFacilityType(data));

                return true;
            }
        } catch (error: any) {
            dispatch(setListFacilityType(error));
            return rejectWithValue(getErrorMessage(error));
        }
        return rejectWithValue(false);
    }
);

export const {
    setListFacilityType,
    resetRegisterState,
    setNewFacilityType,
    setDeleteFacilityType,
    resetUpdateState,
    setUpdateFacilityType,
    resetDeleteState,
    resetListFacilityTypeState,
    setDetailsFacilityType
} = facilityTypeSlice.actions
export const facilityTypeSelector = (state: RootState) => state.facilityType;